import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  initialState: {
    userObj: null,
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setUser(state, action) {
      state.userObj = action.payload;
    },
    clearUserProfile:(state)=>{
      state.userObj=null;
      localStorage.clear(); 
    }
  },
});

export default userSlice.reducer;
export const userAction = userSlice.actions;
